import { useState, useEffect } from 'react';

const navItems = [
  { label: '专题索引', href: '#index' },
  { label: '读者热评', href: '#comments' },
  { label: '平台特色', href: '#features' },
  { label: '热门话题', href: '#topics' },
  { label: '常见问答', href: '#faq' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <header
      id="header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-lg border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px] max-w-[1280px] mx-auto">
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); handleNav('#hero'); }}
            className="whitespace-nowrap text-xl font-heading font-bold text-foreground-900 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-2"
          >
            <span className={`w-7 h-7 rounded-md flex items-center justify-center text-xs font-bold ${scrolled ? 'bg-primary-500 text-background-50' : 'bg-primary-500/90 text-background-50'}`}>
              718
            </span>
            黑料718
          </a>

          <div className="hidden md:flex items-center gap-1">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); handleNav('#hero'); }}
              className={`whitespace-nowrap px-4 py-2 text-sm rounded-md transition-colors cursor-pointer ${
                scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-background-100 hover:text-background-50'
              }`}
            >
              首页
            </a>
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNav(item.href); }}
                className={`whitespace-nowrap px-4 py-2 text-sm rounded-md transition-colors cursor-pointer ${
                  scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-background-200/90 hover:text-background-50'
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer transition-colors ${
              scrolled ? 'text-foreground-700' : 'text-background-100'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 pb-3 px-2 rounded-b-lg">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); handleNav('#hero'); }}
              className="block py-3 px-3 text-sm text-foreground-700 hover:text-primary-600 border-b border-background-100 cursor-pointer rounded-md hover:bg-background-100 transition-colors"
            >
              首页
            </a>
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNav(item.href); }}
                className="block py-3 px-3 text-sm text-foreground-700 hover:text-primary-600 border-b border-background-100 last:border-0 cursor-pointer rounded-md hover:bg-background-100 transition-colors"
              >
                {item.label}
              </a>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
}